// extracted by mini-css-extract-plugin
module.exports = {"main":"allReport_main__11ByA","tabs":"allReport_tabs__2UqNf"};